import axios from 'axios';

import buildInstitutionURL from './buildInstitutionURL';

const apiClient = axios.create({
  baseURL: buildInstitutionURL({ subdomain: 'apiv2' }),
});

export default apiClient;
